const allocation = `${process.env.VUE_APP_URL}/api/v1/allocation/activity-allocations/`;
const activities = `${process.env.VUE_APP_URL}/api/v1/activities/`;
const dimensions = `${process.env.VUE_APP_URL}/api/v1/dimensions/`;
const allocationCalculation = `${process.env.VUE_APP_URL}/api/v1/calculation`;
import { validateResponseError } from "@/store/utils.js";
export default {
  namespaced: true,
  state: {
    getOptionLabelMethod: (option) => { return `${option.source_name} -> ${option.destination_name}` },
    reduceChosenOption: (act) => {
      return { source: act.source, destination: act.destination };
    },
    management: {
      baseUrl: ({ scenario, limit, order, offset, searchTerm }) => `${allocation}?scenario=${scenario}&limit=${limit}${order}${offset}${searchTerm}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Activity Source",
          field: "source_name",
        },
        {
          label: "Dimension Destination",
          field: "destination_name",
        },
        {
          label: "Formula",
          field: "equation",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "",
          field: "manage",
        },
      ],
      rows: [],
      orderField: '',
      orderDict:{
        source_name:"source__name",
        destination_name:"destination__name",
        equation: "equation",
        description: "description"
      },
    },
    source: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/activity-results/by-source/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Activity",
          field: "source_name",
        },
        {
          label: "Original amount",
          field: "original_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Allocated amount",
          field: "allocated_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Source Capacity",
          field: "source_capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
      ],
      rows: [],
      orderField: '',
    },
    destination: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/activity-results/by-destination/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Dimension",
          field: "destination_name",
        },
        {
          label: "Amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
      ],
      rows: [],
      orderField: '',
    },
    aggregated: {
      baseUrl: ({ scenario, limit, offset }) => `${allocationCalculation}/activity-results/get-aggregated/?scenario=${scenario}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Source",
          field: "source_name",
        },
        {
          label: "Destination",
          field: "destination_name",
        },
        {
          label: "Allocated amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Unallocated Capacity",
          field: "unallocated_capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
        {
          label: "Total Cost",
          field: "total_cost",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)} €`; },
          hidden: false,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
      ],
      rows: [],
      orderField: '',
    },
    byLine: {
      baseUrl: ({ scenario, allocation, limit, offset }) => `${allocationCalculation}/activity-results/?scenario=${scenario}&source=${allocation.source}&dimension=${allocation.destination}&limit=${limit}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "ID",
          field: "transaction_id",
        },
        {
          label: "Allocated cost",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Capacity",
          field: "capacity",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: true,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',

        },
        {
          label: "Time Driven Amount",
          field: "time_driven_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: true,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        },
      ],
      rows: [],
      orderField: '',
    },
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    createAllocationForm: {
      source: null,
      destination: null,
      equation: "=",
      description: "",
      splitType: "EVEN",
      allocationDriver: ""
    },
    activityOptions: [],
    dimensionOptions: [],


    resultsOptionsByLine: [],

    currentByLineUrl: null,
    nextByLineUrl: null,
    previousByLineUrl: null,
    totalRecords: null,

    lastCalculation: [{
      calculation_id: null,
      finished_at: null, 
      requested_by_user: null,
    }],

    currentActivityDimensionsDrivers: [],
    allocation_byline_chosen: null,
    debug:{
      mode: "logs",
      errors:[],
      logs:[]
    }
  },
  getters:{
    getDebugData(state){
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_SEARCH_TERM(state, data){
      state[data.subStore].searchTerm = data.searchTerm
    },
    SET_OFFSET(state, data) {
      state[data.subStore].offset = state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength < 0 ? 0 : state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength
    },
    SET_ALLOCATION_FORM(state, data) {
      state.createAllocationForm = data;
    },
    SET_ACTIVITY_DIMENSION_DRIVERS(state, data) {
      state.currentActivityDimensionsDrivers = data;
    },
    SET_ALLOCATION_SOURCE(state, data) {
      let newFormData = { ...state.createAllocationForm };
      newFormData.source = data;
      state.createAllocationForm = newFormData;
    },
    SET_ALLOCATION_DESTINATION(state, data) {
      let newFormData = { ...state.createAllocationForm };
      newFormData.destination = data;
      state.createAllocationForm = newFormData;
    },
    SET_ALLOCATION_EQUATION(state, data) {
      let newFormData = { ...state.createAllocationForm };
      newFormData.equation = data;
      state.createAllocationForm = newFormData;
    },
    SET_ALLOCATION_SPLIT_TYPE(state, data) {
      state.createAllocationForm.splitType = data;
      if (data == 'FORMULA') {
        state.createAllocationForm.equation = "="
      }
    },
    SET_ALLOCATION_DRIVER(state, data) {
      state.createAllocationForm.allocationDriver = data;
    },
    SET_ALLOCATION_DESCRIPTION(state, data) {
      let newFormData = { ...state.createAllocationForm };
      newFormData.description = data;
      state.createAllocationForm = newFormData;
    },
    SET_ACTIVITIES_OPTIONS(state, data) {
      state.activityOptions = data;
    },
    SET_DIMENSIONS_OPTIONS(state, data) {
      state.dimensionOptions = data;
    },
    CLEAR_ALLOCATION_FORM(state) {
      state.createAllocationForm = {
        source: null,
        destination: null,
        equation: "=",
        description: "",
        splitType: "EVEN",
        allocationDriver: ""
      }
    },
    //CALCULATIONS
    SET_LAST_CALCULATION(state, data) {
      if(!data){
        return;
      }
      state.lastCalculation = data;
    },
    SET_AGGREGATED_ALLOCATION_RESULTS_BY_LINE(state, data) {
      state.resultsByLineRows = data;
    },
    SET_SOURCE_COLUMNS_TDABC(state, data) {
      state.source.columns.forEach(element => {
        if (element.label == "Source Capacity") { element.hidden = !data }
      });      
    },
    SET_DESTINATION_COLUMNS_TDABC(state, data) {
      state.destination.columns.forEach(element => {
        if (element.label == "Capacity") { element.hidden = !data }
      });      
    },
    SET_BY_LINE_COLUMNS_TDABC(state, data) {
      state.byLine.columns.forEach(element => {
        if (element.label == "Time Driven Amount") { element.hidden = !data }
        if (element.label == "Capacity") { element.hidden = !data }
      });      
    },
    SET_AGGREGATED_COLUMNS_TDABC(state, data) {
      state.aggregated.columns.forEach(element => {
        if (element.label == "Total Cost") { element.hidden = !data }
        if (element.label == "Unallocated Capacity") { element.hidden = !data }
      });      
    },


    CLEAR_RESULTS_DATA(state) {
      state.source.rows = [];
      state.destination.rows = [];
      state.aggregated.rows = [];
      state.byLine.rows = [];
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },
    SET_ALLOCATION_BY_LINE_CHOSEN(state, data) {
      if(!data) return;
      state.allocation_byline_chosen = data;
    },
    CLEAR_BY_LINE_RESULTS(state) {
      state.byLine.rows = [];
      state.resultsOptionsByLine = [];
      state.allocation_byline_chosen = null;
    },
    ////////////////////////////////////////////////////////////////
    SET_COUNT(state, data) {
      state[data.subStore].count = data.count;
    },
    SET_NEXT(state, data) {
      state[data.subStore].nextUrl = data.next;
    },
    SET_PREVIOUS(state, data) {
      state[data.subStore].previousUrl = data.previous;
    },
    SET_CURRENT(state, data) {
      state[data.subStore].currentUrl = data.current;
    },
    SET_ROWS(state, data) {
      if(!data.rows){
        return;
      }
      let copy = { ...state[data.subStore] }
      copy.rows = data.rows;
      state[data.subStore] = copy;
    },
    SET_PAGE_LENGTH(state, data) {
      state[data.subStore].pageLength = data.pageLength;
    },
    CLEAR_TABLE_DATA(state, data){
      if(data.subStore){
        state[data.subStore].rows = [];
      }
    },
    SET_ORDER_FIELD(state, data){
      if(data.subStore && state[data.subStore].orderDict){
        switch(data.orderType){
          case 'asc':
            state[data.subStore].orderField = state[data.subStore].orderDict[data.orderField];
            break;
          case 'desc':
            let orderField = state[data.subStore].orderDict[data.orderField]
            state[data.subStore].orderField = orderField ? `-${orderField}`: null;
            break;
          default:
            state[data.subStore].orderField = null;
            break;
        }
      }
    },
    SET_DEBUG_LOGS(state, data){
      state.debug.logs = data;
    },
    SET_DEBUG_ERRORS(state, data){
      state.debug.errors = data;
    },
    SET_DEBUG_MODE(state, data){
      state.debug.mode = data;
    },
  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId, subStore, isTdabc }) {
      let allocation = state.allocation_byline_chosen
      if(subStore == "byLine" && !allocation){
        return
      }
      let order = state[subStore].orderField ? `&ordering=${state[subStore].orderField}` : ''
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      let searchTerm = state[subStore].searchTerm ? `&search=${state[subStore].searchTerm}` : ''
      let getData =
        state[subStore].currentUrl || state[subStore].baseUrl({ scenario: scenarioId, limit: state[subStore].pageLength, allocation: allocation, order: order, offset: offset, searchTerm: searchTerm });
      return context.$http.get(getData).then((res) => {
        commit("SET_COUNT", { subStore, count: res.data.count });
        commit("SET_NEXT", { subStore, next: res.data.next });
        commit("SET_PREVIOUS", { subStore, previous: res.data.previous });
        commit("SET_ROWS", { subStore, rows: res.data.results ? res.data.results : res.data });
        if(subStore === "source") {commit("SET_SOURCE_COLUMNS_TDABC", isTdabc)};
        if(subStore === "destination") {commit("SET_DESTINATION_COLUMNS_TDABC", isTdabc)};
        if(subStore === "byLine") {commit("SET_BY_LINE_COLUMNS_TDABC", isTdabc)};
        if(subStore === "aggregated") {commit("SET_AGGREGATED_COLUMNS_TDABC", isTdabc)};
      })
    },
    setNextAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].nextUrl });
    },
    setPreviousAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].previousUrl });
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    deleteAllocation({ state }, { context, id }) {
      let deleteUrl = `${allocation}${id}`;
      return context.$http.delete(deleteUrl);
    },
    getActivities({ commit }, { context, modelId }) {
      let getUrl = `${activities}?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_ACTIVITIES_OPTIONS", res.data);
        });
    },
    getDimensions({ commit }, { context, modelId }) {
      let getUrl = `${dimensions}?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_DIMENSIONS_OPTIONS", res.data);
        });
    },
    createUpdateAllocation({ state }, { context, mode, scenarioId }) {
      const formulaConstructor = {
        EVEN: () => { return "EVEN"; },
        DRIVER: () => { return `DRIVER:${state.createAllocationForm.allocationDriver}` },
        FORMULA: () => { return state.createAllocationForm.equation }
      }

      let dataToPost = { ...state.createAllocationForm };
      dataToPost.scenario = scenarioId;
      dataToPost.equation = formulaConstructor[dataToPost.splitType]();

      if (mode == "UPDATE") {
        let patchUrl = `${allocation}${state.createAllocationForm.id}/`;
        return context.$http.patch(patchUrl, dataToPost);
      }
      let postUrl = `${allocation}`;
      return context.$http.post(postUrl, dataToPost);
    },
    getCurrentActivityDimensionDriver({ state, commit }, { context }) {
      context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/drivers?dimension=${state.createAllocationForm.destination}&driver_type=decimal`
      )
        .then((res) => {
          commit("SET_ACTIVITY_DIMENSION_DRIVERS", res.data.items);
        });
    },
    // CALCULATIONS
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      commit("CLEAR_BY_LINE_RESULTS");
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACTIVITY_TO_DIMENSION_DIRECT`;
      return context.$http.get(resultsUrl)
        .then(res => {
          
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "fourthAllocation");
        })
    },
    getLastCalculation({ commit, dispatch }, { context, scenarioId }) {
      commit("CLEAR_BY_LINE_RESULTS");
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACTIVITY_TO_DIMENSION_DIRECT`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "fourthAllocation");
        })
    },
    calculateResults({ state, dispatch, commit }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/activity-results/generate/`;
      return context.$http.post(resultsUrl, { scenario: scenarioId })
        .then(res => {
          commit("CLEAR_RESULTS_DATA");
          commit("CLEAR_BY_LINE_RESULTS");
          commit("SET_LAST_CALCULATION", [res.data])
        });
    },
    getSourceAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "source", scenarioId })
    },
    getDestinationAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "destination", scenarioId })
    },
    getAggregatedAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "aggregated", scenarioId })
    },
    getAggregatedByLineAllocationResults({ dispatch }, { context, allocation, scenarioId, isTdabc }) {
      if (allocation?.source && allocation?.destination) {
        dispatch("getTableData", { context, subStore: "byLine", scenarioId, allocation: allocation, isTdabc:isTdabc })
      }
    },
    getCalculationLogs({commit, state},{context}){
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/calculation/logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail )
        }).catch(err => {
          validateResponseError(this, err, "fourthAllocation");
        })
    },
    getCalculationErrors({commit},{}){
      commit("SET_DEBUG_ERRORS",["Not implemented"]);
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl =  `${allocationCalculation}/calculations/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
  },
}